<template>
   <div>
     <ul v-if="filterList" class="cs-2depth">
       <li v-for="(filterItem, index) in filterList" :key="index" :class="filterItem.name === category ? 'cs-2depth-on' : ''" @click="goFilterPage(filterItem.name)"><button>{{filterItem.title}}</button></li>
     </ul>

     <div class="policy-wrap" v-if="termsData">
       <div id="termsContent" class="policy-content">
         <h2 class="policy-tit" tabindex="0">{{ getTitle }} <small>시행일자 : {{termsData.effectivedate}} </small></h2>
         <div class="policy-desc" tabindex="0" v-html="termsData.content"></div><!--policy-desc//-->
         <button @click="termsPrint()" id="btnPrint" class="print-btn">
           <span>인쇄하기</span>
         </button>
         <div class="filter-wrap" v-if="versionFilterList.length > 0">
           <div class="filter-item">
             <label>
               <select v-model="selectedVersion" :disabled="versionFilterList.length === 1" @change="changeFilter">
                 <option v-for="(filter, index) in versionFilterList" :key="index" :value="filter.version">{{filter.text}}</option>
               </select>
             </label>
           </div>
         </div>
       </div>
     </div>
   </div>
</template>

<script>
import { getTerms } from '@/common/utils/request'
import _ from 'lodash'
import queryString from '@/common/utils/querystring'
import { titleTagNameChange } from '@/common/utils/common'
export default {
  name: 'Agreement',
  data () {
    return {
      data: true, // 임시 웨이브온 flag 값
      filterList: [
        { title: '서비스 이용약관', link: '/customer/agreement.html?category=service', name: 'service' },
        { title: '유료상품 이용약관', link: '/customer/agreement.html?category=paid', name: 'payment' },
        { title: '개인정보 처리방침', link: '/customer/agreement.html?category=privacy', name: 'privacy' },
        { title: '청소년 보호정책', link: '/customer/agreement.html?category=youth', name: 'youth' },
        { title: '웨이브온 사업자 이용약관', link: '/customer/agreement.html?category=pooqzone', name: 'pooqzone' },
        { title: '웨이브온 개인정보 처리방침', link: '/customer/agreement.html?category=pooqzone_privacy', name: 'pooqzone_privacy' }
      ],
      category: queryString.getQueryParamValue(this.$route, 'category', 'service'),
      tabIndex: 0,
      termsData: undefined,
      termsTitle: '서비스 이용약관',
      version: queryString.getQueryParamValue(this.$route, 'version', 'last'),
      versionFilterList: [],
      selectedVersion: ''

    }
  },
  computed: {
    getTitle () {
      let selectedFilter = this.filterList.filter((filter) => {
        if (filter.name === this.category) {
          return filter
        }
      })
      return selectedFilter[0].title
    }
  },
  methods: {
    getAgreementVersion (tempVersion, hash) {
      this.$router.push({
        query: {
          category: this.category,
          version: tempVersion
        },
        hash: hash
      })
    },
    goFilterPage (category) {
      this.$router.push({
        query: {
          category: category
        }
      })
    },
    // 프린트
    termsPrint () {
      let objWin = null
      let strFeature

      strFeature = 'width=1024,height=800,toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=no'
      objWin = window.open('', 'print', strFeature)
      self.focus()

      objWin.document.open()
      objWin.document.write('<html><head><style type="text/css">')
      objWin.document.write('.policy-tit { font-family: \'NanumSquareBold\'; font-size: 24px; color: #a5a5a5; margin-bottom: 19px; margin-top: 30px; }')
      objWin.document.write('.policy-tit > small { font-size: 14px; color: #666; }')
      objWin.document.write('.policy-desc { font-family: \'NanumSquare\'; font-size: 14px; line-height: 1.71em; color: #a5a5a5; border-radius: 6px; background-color: #f8f8f8; padding: 28px 40px; }')
      objWin.document.write('</style></head><body>')

      document.getElementById('btnPrint').style.display = 'none'
      objWin.document.write(document.getElementById('termsContent').innerHTML)
      document.getElementById('btnPrint').style.display = ''

      objWin.document.write('</body></html>')
      objWin.document.close()
      objWin.print()
      objWin.close()
    },
    getAgreementInfo () {
      this.termsTitle = this.filterList[this.tabIndex].title
      this.filterList.forEach((filter) => {
        if (filter.name === this.category) {
          this.termsTitle = filter.title
        }
      })

      getTerms({ type: this.category, version: this.version }).then(({ data }) => {
        this.termsData = data
        this.versionFilterList = _.get(this.termsData, 'list', [])
        const selectedFilterIndex = _.findIndex(this.versionFilterList, { version: _.get(this.termsData, 'version', 'last') })
        this.selectedVersion = _.get(this.versionFilterList, [selectedFilterIndex, 'version'], 'last')
      })
    },
    changeFilter () {
      this.$router.push({
        query: {
          category: this.category,
          version: this.selectedVersion
        },
        hash: _.get(this.$route, 'hash', '')
      })
    }
  },
  created () {
    if (this.category === 'paid') this.category = 'payment'
    this.getAgreementInfo()
    titleTagNameChange('이용약관 : 웨이브 고객센터')
  },
  watch: {
    $route (to, from) {
      this.version = _.get(this.$route, ['query', 'version'], 'last')
      this.category = _.get(this.$route, ['query', 'category'], 'service')
      this.getAgreementInfo()
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/member.scss"></style>
<style lang="scss" src="@/assets/scss/category/service.scss"></style>
<style scoped>
  .filter-wrap{
    position: static;
    top: auto;
    right: auto;
    margin-top: 40px;
    padding: 0 20px;
    text-align: center;
  }

  .filter-item label{
    display: inline-block;
  }

  .filter-item select{
    width: auto;
    overflow: visible;
    text-overflow: clip;
  }
</style>
